import { render, staticRenderFns } from "./AadharNumberChange.vue?vue&type=template&id=52b2428f"
import script from "./AadharNumberChange.vue?vue&type=script&lang=js"
export * from "./AadharNumberChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports